import { LayoutState } from '~/src/stores/layout'
import LayoutServiceInterface from '~/src/utils/layout/LayoutServiceInterface'

export default class LayoutTermsAndConditionsServiceStyleThree implements LayoutServiceInterface {
  public getLayout(): Partial<LayoutState> {
    return {
      header: {
        display: true,
        displayMenuBurger: true,
        displayProductSearch: false,
        displayLocationSearch: false,
        displayCart: false,
        displayLanguagesSelector: true,
        displayDeliveryOptions: false,
        displayUserActions: false,
        displayCurrentFirm: false,
        logo: {
          disableLink: false
        },
        title: '',
        type: 'navigation'
      },
      subHeader: {
        display: false,
        variant: 'default'
      },
      content: {
        displayNotification: false
      },
      mainSideBar: {
        display: false,
        displayCart: false,
        displayDeliveryOptions: false,
        displayOrderSummary: false
      },
      footer: {
        display: true,
        displayGoToCartBtn: false,
        displayGoToCheckoutBtn: false,
        displayInformations: true,
        displayLinks: true
      },
      mobileNavigation: {
        display: true
      }
    }
  }
}
